import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M10 14V6l4 4zM8 6h1v8H8V6z'],
  height: 20,
  width: 20,
});
